export const webLocksSupported = () => {
  return typeof navigator !== 'undefined' && 'locks' in navigator;
};

export type LockLease = { key: string; release: () => void };

export async function acquireLease(key: string): Promise<LockLease | null> {
  if (!webLocksSupported()) {
    return null;
  }

  let releaseLock: (() => void) | undefined;
  let resolveAcquiredLock: (value: boolean) => void;
  const acquireLock = new Promise<boolean>((resolve) => {
    resolveAcquiredLock = resolve;
  });
  const holdLock = new Promise<void>((resolve) => {
    releaseLock = resolve;
  });
  navigator.locks.request(
    key,
    { mode: 'exclusive', ifAvailable: true },
    async (lock) => {
      if (!lock) {
        resolveAcquiredLock(false);
        return;
      }

      resolveAcquiredLock(true); // Signal acquisition explicitly
      await holdLock; // keep lock until release()
    },
  );
  const lockAcquired = await acquireLock; // Wait for explicit signal
  return lockAcquired && releaseLock ? { key, release: releaseLock } : null;
}
